import CreateDownloadFromResource from "../UseCase/CreateDownloadFromResource";
import getCreateDownload from "./createDownload";
import getDocumentDownloadFactory from "./documentDownloadFactory";

const createDownloadFromResource: CreateDownloadFromResource = new CreateDownloadFromResource(
    getCreateDownload(),
    getDocumentDownloadFactory()
);

export default function getCreateDownloadFromResource(): CreateDownloadFromResource {
    return createDownloadFromResource;
}